/**
 * Playbooks HTTP service (PX-W6.5) — the two org-scoped READ routes. No
 * write verbs exist; every demo affordance without a route stays
 * concept-badged on the page (AC-13).
 */

import { apiClient } from '@/services'

import type { Playbook, TenantPolicy } from '../types'

export const playbooksService = {
  /** The org's playbooks (the seeded stub carries `version: "v0"`). */
  list(): Promise<Playbook[]> {
    return apiClient.get<Playbook[]>('/{orgId}/playbooks')
  },

  /** The org's tenant policy. */
  policy(): Promise<TenantPolicy> {
    return apiClient.get<TenantPolicy>('/{orgId}/tenant-policy')
  }
}
